import { makeFilterString } from "../../utils/Helper";
import {
  GetServicesSuccess,
  ServicesLoading,
  SetService,
  GetServiceDetailsSuccess,
  GetScrollServicesSuccess,
} from "./Actions";

import { reduxRequest } from "../../../../common/utils/reduxRequest";

export const getServicesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "list",
    successFunction: GetServicesSuccess,
    url: `/admin/lookups/services${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getScrollServicesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "filter-list-services",
    successFunction: GetScrollServicesSuccess,
    url: `/admin/lookups/services${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createServiceRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "add",
    successFunction: SetService,
    action: variables?.action,
    url: `/admin/lookups/services`,
    method: "post",
    data: variables?.body,
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getServiceDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "details",
    successFunction: GetServiceDetailsSuccess,
    url: `/admin/lookups/services/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteServiceRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "delete service",
    action: variables?.action,
    url: `/admin/lookups/services/${variables?.id}`,
    method: "delete",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateServiceRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ServicesLoading,
    loadingType: "update service",
    url: `/admin/lookups/services/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
